const PODCAST_REPORTING_ENABLED_MARKETS = [
  'at',
  'au',
  'be-fr',
  'be-nl',
  'bg-bg',
  'bg-en',
  'cy',
  'de',
  'de-en',
  'dk-da',
  'dk-en',
  'es',
  'es-ca',
  'es-gl',
  'fr',
  'gr',
  'ie',
  'in-en',
  'in-hi',
  'it',
  'lu-de',
  'lu-fr',
  'mt',
  'nl',
  'nl-en',
  'nz',
  'pl',
  'ph-en',
  'ph-tl',
  'pt-en',
  'pt-pt',
  'se',
  'us',
  'us-es',
];

export const isPodcastReportingEnabledForMarket = (market: string) => {
  return new Set(PODCAST_REPORTING_ENABLED_MARKETS).has(market);
};

// Music Videos reporting availability
const MUSIC_VIDEOS_RELEASED_MARKETS = [
  'br-en',
  'br-pt',
  'co-en',
  'co-es',
  'eg-ar',
  'eg-en',
  'de',
  'de-en',
  'id-en',
  'id-id',
  'it',
  'ke-en',
  'ke-sw',
  'nl',
  'nl-en',
  'ph-en',
  'ph-tl',
  'pl',
  'se',
  'uk',
];

export const isMusicVideosReportingEnabledForMarket = (market: string) => {
  return new Set(MUSIC_VIDEOS_RELEASED_MARKETS).has(market);
};

// Courses reporting availability
const COURSES_RELEASED_MARKETS = ['uk'];

export const isCoursesReportingEnabledForMarket = (market: string) => {
  return new Set(COURSES_RELEASED_MARKETS).has(market);
};
